<template>
	<div class="pay">
		<div class="agree_privacy" v-if="agreePrivacy">
			<p style="font-size: 16px;
			margin-bottom: 15px;text-align: center;">温馨提示</p>
			<p>我们非常重视保护您的个人信息与隐私！依据最新的监管要求，我们特向您说明如下：</br>
1.为向您提供电子数据的证据化（下称“电子证据”）等服务，我们将根据法律及<span style="color: #19CBA6;" @click="$router.push('/privacy')">《司法电子证据云平台隐私政策》</span>收集、使用提供服务所必需的个人信息；</br>
2.基于您的明示授权，我们可能会调取您的地理位置等设备权限，您有权拒绝或取消授权；</br>
3.我们会采取严格的技术措施和管理措施以保护您的信息安全；</br>
4.未经您同意，我们不会向第三方共享您的个人信息。</br>
您可以查询、更正、删除您的个人信息，我们也提供撤回同意、注销帐号、投诉举报的渠道。</p>
<div class="btns">
	<p @click="agree(0)">不同意</p>
	<p @click="agree(1)">同意</p>
</div>
		</div>
		<div class="top">
			<!--<div class="imgDiv clearfix">
				<div class="left">
					<h3>购买认证次数</h3>
					<p>当前认证次数不足</p>
				</div>
				<img src="../assets/img/rz.png" alt="">
			</div>-->
			<img src="../assets/img/banner.png" class="banner" alt="">
			<h3>您可以获得中经天平司法电子证据云平台提供的：</h3>
			<p><span>1. </span>可信时间认证：国家授时中心签发具有法律效力的可信时间认证</p>
			<p style="margin-bottom: 20px;"><span>2. </span>中经天平电子证据认证：支持各类电子证据文件的证据固化保全，保证电子证据的真实、完整、防篡改</p>
			<!--<div class="btnDiv clearfix">
				<button @click="pay_text = '1'" :class="pay_text==1?'act':null">20元/次</button>
				<button @click="pay_text = '2'" :class="pay_text==2?'act':null">196元/10次</button>
			</div>-->
		</div>
		<h3>充值说明</h3>
		<p><span>1. </span>请使用支付宝进行充值；</p>
		<p><span>2. </span>购买认证次数后，即可使用证据认证功能，使用此功能将消耗认证次数；</p>
		<p><span>3. </span>认证次数一旦购买不提现，不退款，只能用于证据认证服务；</p>
		<p><span>4. </span>本服务由中经天平司法电子证据云平台提供</p>
		<p><span>5. </span>中经天平司法电子证据云官网：www.bjzjtp.com，客服电话:010-60608644 工作日（9:00~18:00）</p>
		<div class="bottom clearfix">
			<div>{{pay_text == 1 ? '20元/次' : '196元/10次'}}</div>
			<button @click="buy()">立即购买</button>
			<p class="changeBox" :class="showP?'actP':null" @click="showP=!showP">选择充值金额</p>
			<div class="btnDiv clearfix" style="padding-left: 0;" v-if="showP">
				<!--<button @click="pay_text = '1'" :class="pay_text==1?'act':null">20元/次</button>
				<button @click="pay_text = '2'" :class="pay_text==2?'act':null">196元/10次</button>-->
				<button @click="change1" :class="pay_text==1?'act':null">20元/次</button>
				<button @click="change2" :class="pay_text==2?'act':null">196元/10次</button>
			</div>
		</div>
		<div class="form"></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				pay_text: "1",
				showP: false,
				agreePrivacy:true//同意隐私政策弹窗
			};
		},
		// 父组件传过来的值
		props: [],
		components: {},
		computed: {},
		created() {
			document.title = "支付";
			//			if(sessionStorage.userid == undefined) {
			this.authcode = this.$route.query.authcode;
			this.appkey = this.$route.query.appkey;
			sessionStorage.setItem("authcode", this.authcode);
			sessionStorage.setItem("appkey", this.appkey);
			this.getUserInfo();
			//此为支付页面
			this.onBack()
			//统计
			this.tj(this.appkey, this.$route.path)
			//			}
		},
		mounted() {},
		// 组件销毁后
		destroyed: function() {},
		methods: {
			// 隐私政策是否同意
			agree(number){
				const self = this
				console.log(number)
				sessionStorage.setItem("agree", number);
				if(number==0){
					self.agreePrivacy = false
				}else{
					this.$axios
						.post("/v2/updateAgree", {
							appkey: sessionStorage.appkey,
							token: sessionStorage.token,
							sign: $.md5(
								sessionStorage.token + sessionStorage.appkey + self.appsecret
							),
							userid: sessionStorage.userid,
						})
						.then(function(res) {
							console.log(res.data);
							if(res.data.code == 2001) {
								self.agreePrivacy = false
							}
						})
						.catch(function(err) {
							console.log(err);
						});
				}
				
			},
			//调用方法
			onBack: function() {
				try {
					CSElectricProofJSMethodObject.onBack(0)
				} catch(e) {
					console.log('出现错误, 如果在非android环境下访问, 出现该警告是正常的.')
				}
			},
			change1: function() {
				this.pay_text = '1'
				this.showP = false
			},
			change2: function() {
				this.pay_text = '2'
				this.showP = false
			},
			buy: function() {
				let self = this;
				if(sessionStorage.getItem("agree")==0){
					self.agreePrivacy = true
					return false
				}
				this.$axios
					.post("/v2/buildOrder", {
						appkey: sessionStorage.appkey,
						token: sessionStorage.token,
						sign: $.md5(
							sessionStorage.token + sessionStorage.appkey + self.appsecret
						),
						userid: sessionStorage.userid,
						paytype: self.pay_text
					})
					.then(function(res) {
						console.log(res.data);
						$(".form").html(res.data);
						//						self.showP = true
						//						setTimeout(() => {
						//							self.showP = true
						//						}, 100);
						// self.$toast(res.data.msg);
						if(res.data.code == 2001) {}
					})
					.catch(function(err) {
						console.log(err);
					});
			},
			showP1: function() {
				//								console.log(document.getElementById('alipaysubmit'))
				alert(document.getElementById('alipaysubmit'))
				//				this.$toast(document.getElementById('alipaysubmit'));

				//				setTimeout(() => {
				document.getElementById('alipaysubmit').submit()
				//				}, 1000);

				//				document.forms['alipaysubmit'].submit();
			},
			//			getToken: function() {
			//				let self = this;
			//				this.$axios
			//					.post("/Authapi/authToken", {
			//						appkey: this.appkey
			//					})
			//					.then(function(res) {
			//						console.log(res.data);
			//						if(res.data.code == 2000) {
			//							sessionStorage.setItem("token", res.data.data.token);
			//							self.getUserInfo();
			//						}
			//					})
			//					.catch(function(err) {
			//						console.log(err);
			//					});
			//			},
			getUserInfo: function() {
				let self = this;
				this.$axios
					.post("/v2/getMemberInfo", {
						appkey: this.appkey,
						authcode: sessionStorage.authcode
					})
					.then(function(res) {
						console.log(res.data);
						if(res.data.code == 2001) {
							if(res.data.data.is_agree_privacy==0){
								self.agreePrivacy = true
							}else{
								self.agreePrivacy = false
							}
							sessionStorage.setItem("agree", res.data.data.is_agree_privacy);
							sessionStorage.setItem("userid", res.data.data.userid);
							sessionStorage.setItem("token", res.data.data.token);
						}
					})
					.catch(function(err) {
						console.log(err);
					});
			}
		},
		watch: {}
	};
</script>
<style scoped lang="less">
	.pay {
		width: 100%;
		min-height: 100vh;
		overflow-y: auto;
		padding-bottom: 80px;
		box-sizing: border-box;
		.agree_privacy{
			width: 90%;
			position: fixed;
			top: 20%;
			left: 5%;
			background: #D8D8D8;
			z-index: 11;
			padding: 20px;
			box-sizing: border-box;
			border-radius: 8px;
			font-size: 14px;
			.btns{
				width: 100%;
				overflow: hidden;
				margin-top: 20px;
				p{
					width: 50%;
					height: 50px;
					line-height: 50px;
					text-align: center;
					float: left;
				}
			}
		}
		.top {
			width: 100%;
			overflow: hidden;
			background: #ffffff;
			box-shadow: 0 2px 4px 0 rgba(223, 223, 223, 0.5);
			>h3 {
				font-size: 12px;
				color: #333;
				line-height: 26px;
				padding-left: 24px;
				margin: 0 0 8px 0;
			}
			>p {
				font-size: 14px;
				color: #555;
				line-height: 26px;
				margin-bottom: 7px;
				padding-left: 16px;
				margin-left: 24px;
				margin-right: 24px;
				position: relative;
				span {
					position: absolute;
					left: 0;
					top: 0;
				}
			}
			/*>img {
				width: 126px;
				display: block;
				margin: 75px auto 50px auto;
			}
			.imgDiv {
				img {
					width: 126px;
					display: block;
					float: right;
					margin: 26px 53px 42px 0;
				}
				.left {
					float: left;
					width: 120px;
					margin: 50px 0 0 6%;
					h3,
					p {
						color: #333333;
						line-height: 29px;
					}
					h3 {
						font-size: 19px;
					}
					p {
						font-size: 14px;
					}
				}
			}*/
			.banner {
				width: 100%;
				height: 188px;
				display: block;
			}
			.btnDiv {
				button {
					outline: none;
					float: left;
					width: calc(~"(100% - 72px) / 2");
					font-family: PingFangSC-Regular;
					font-size: 16px;
					color: #19cba6;
					height: 42px;
					line-height: 42px;
					border: 0;
					box-sizing: border-box;
					margin-bottom: 47px;
					border: 1px solid rgba(25, 203, 166, 0.3);
					&:nth-of-type(1) {
						margin-right: 24px;
						margin-left: 24px;
						/*background: #19CBA6;*/
					}
					/*&:nth-of-type(2) {*/
					/*border: 1px solid rgba(25, 203, 166, 0.3);*/
					/*}*/
				}
				.act {
					background: #19CBA6;
					color: #fff;
				}
			}
		}
		>h3 {
			font-size: 12px;
			color: #333;
			line-height: 26px;
			padding-left: 24px;
			margin: 19px 0 8px 0;
		}
		>p {
			font-size: 14px;
			color: #555;
			line-height: 26px;
			margin-bottom: 7px;
			padding-left: 16px;
			margin-left: 24px;
			margin-right: 24px;
			position: relative;
			span {
				position: absolute;
				left: 0;
				top: 0;
			}
		}
		.bottom {
			position: fixed;
			z-index: 997;
			bottom: 0;
			left: 0;
			width: 100%;
			background: #ffffff;
			box-shadow: 0 -2px 5px 0 rgba(218, 235, 255, 0.5);
			>div {
				font-size: 16px;
				color: #333333;
				height: 60px;
				line-height: 50px;
				float: left;
				padding-left: 10px;
				box-sizing: border-box;
			}
			button {
				font-size: 14px;
				color: #ffffff;
				width: 92px;
				height: 60px;
				line-height: 60px;
				float: right;
				border: 0;
				background: #19CBA6;
				box-shadow: 0 -2px 5px 0 rgba(218, 235, 255, 0.5);
			}
			.btnDiv {
				width: 100%;
				position: absolute;
				top: -84px;
				button {
					outline: none;
					/*float: left;*/
					width: 100%;
					font-family: PingFangSC-Regular;
					font-size: 16px;
					color: #666666;
					height: 42px;
					line-height: 42px;
					border: 0;
					background: #fff;
					padding-left: none;
					box-sizing: border-box;
					/*margin-bottom: 47px;*/
					/*border: 1px solid rgba(25, 203, 166, 0.3);*/
					/*&:nth-of-type(1) {
						margin-right: 24px;
						margin-left: 24px;
					}*/
					/*&:nth-of-type(2) {*/
					/*border: 1px solid rgba(25, 203, 166, 0.3);*/
					/*}*/
				}
				.act {
					background: #F2F2F2;
					color: #F45D15;
				}
			}
			.changeBox {
				height: 30px;
    line-height: 30px;
    float: right;
    border-radius: 50px;
    font-family: PingFangSC-Regular;
    padding: 0 25px;
    font-size: 12px;
    color: #333333;
    text-align: center;
    padding-left: 15px;
    margin-top: 10px;
    background: #F2F2F2 url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAPCAYAAAD+pA/bAAAAAXNSR…Ufv38fBmr4y/T/v21rX99jmBzV6MqiIrWa0lJlqhk4JAwCAOi0Y0fB4O+mAAAAAElFTkSuQmCC) no-repeat 90% center;
    background-size: 8px 5px;
    margin-right: 10px;
			}
			.actP {
				background: #F2F2F2 url(../assets/img/up.png) no-repeat 90% center;
				background-size: 8px 5px;
			}
		}
	}
</style>